export default __webpack_public_path__ + "9d678526da0449c21cd958a46520653e.png";